import { render, staticRenderFns } from "./waitLineManage.vue?vue&type=template&id=5dfec200&scoped=true&"
import script from "./waitLineManage.vue?vue&type=script&lang=js&"
export * from "./waitLineManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfec200",
  null
  
)

export default component.exports